import request from "../Utils/Request";

export function getData(url: string, config = {}) {
  return request.get(url, config);
}
